import { useState, useEffect } from 'react';

import { hashDomain } from '../settings/hashDomain';

export const useDomain = () => {
  const [hashedDomain, setHashedDomain] = useState<string | null>(null);

  useEffect(() => {
    const fetchHashedDomain = async () => {
      const hashed = await hashDomain(window.location.hostname);

      setHashedDomain(hashed);
    };

    fetchHashedDomain();
  }, []);

  return hashedDomain;
};
